module.exports = __webpack_public_path__ + "static/media/cloud-upload.4ab85151.svg";